<span mat-dialog-title class="relative"
  >{{ 'Configurazione Azione' | siaTranslate }}
  <button mat-dialog-close class="absolute right-2 top-2">
    <mat-icon>close</mat-icon>
  </button>
</span>
<div
  mat-dialog-content
  class="flex h-full w-full flex-col gap-2 overflow-hidden p-1"
>
  <div class="flex flex-col gap-2 overflow-auto">
    <div class="font-semibold">Generale</div>
    <sia-textarea-box
      [(value)]="selectedAction.description"
      [disabled]="false"
      label="Descrizione"
      info="Indica nello specifico di cosa si occupa l'azione nel workflow"
      [textAreaMinHeight]="400"
      [textAreaMaxHeightVh]="'400px'"
      [forceDisableAI]="true"
    ></sia-textarea-box>

    <div class="font-semibold">Attivazione</div>
    <sia-textarea-box
      label="Condizione di attivazione in base a genitori"
      [(value)]="selectedAction.parentsCondition"
      [disabled]="false"
      [textAreaMinHeight]="200"
      [textAreaMaxHeightVh]="'200px'"
      [forceDisableAI]="true"
    >
    </sia-textarea-box>
    <sia-textarea-box
      label="Condizione di attivazione"
      [(value)]="selectedAction.enableCondition"
      [disabled]="false"
      [textAreaMinHeight]="200"
      [textAreaMaxHeightVh]="'200px'"
      [forceDisableAI]="true"
    >
    </sia-textarea-box>
    <div class="font-semibold">Input/Output</div>
    <sia-text-box
      label="Variabile di Output"
      info="Nome della variabile che contiene l'output della azione. Può essere utilizzata come input nelle azioni successive ad essa."
      [(value)]="selectedAction.output"
      [disabled]="false"
    >
    </sia-text-box>
    <div class="flex flex-row">
      <sia-check-box
        class="w-1/4"
        [label]="'Prosegui in caso di padre in errore'"
        [(value)]="selectedAction.continueOnConditionFalse"
      >
      </sia-check-box>
      <sia-check-box
        class="w-1/4"
        [label]="'Prosegui in caso di errore'"
        [(value)]="selectedAction.continueOnError"
      >
      </sia-check-box>
      <div class="w-1/4"></div>
      <div class="w-1/4"></div>
    </div>
    <div class="font-semibold">Specifiche</div>
    @switch (selectedAction.type) {
      @case ('SQL') {
        <sia-textarea-box
          label="Query SQL"
          [(value)]="selectedAction.query"
          [disabled]="false"
          [textAreaMinHeight]="200"
          [textAreaMaxHeightVh]="700"
          [forceDisableAI]="true"
          info="Query SQL, ad esempio select, update o chiamata a stored procedure. Con @NomeVariabileInSQL è il placeholder tra query sql e variabile nel workflow. E' possibile settare il collegamento nella sezione Parametri."
          [status]="!selectedAction.query ? 'error' : null"
        ></sia-textarea-box>

        <!-- <sia-sql-editor [(query)]="selectedAction.query"> </sia-sql-editor> -->

        <sia-text-box
          label="Stringa di connessione"
          info="Stringa di connessione al database, ad esempio per SQL Server: Server=myServerAddress;Database=myDataBase;User Id=myUsername;Password=myPassword;"
          [(value)]="selectedAction.connectionStringName"
          [disabled]="false"
        ></sia-text-box>
        <sia-select-box
          [selectBoxOptions]="{
            fixedDataSource: sqlResultTypes,
            value: selectedAction.resultType,
          }"
          [(value)]="selectedAction.resultType"
          [disabled]="false"
          label="Tipo del risultato"
        ></sia-select-box>
        <ng-container
          [ngTemplateOutlet]="accordionParameters"
          [ngTemplateOutletContext]="{ type: 'parameters' }"
        ></ng-container>
      }
      @case ('FileManager') {
        <sia-select-box
          [selectBoxOptions]="{
            fixedDataSource: fileManagerOperation,
            value: selectedAction.operation,
          }"
          [(value)]="selectedAction.operation"
          [disabled]="false"
          label="Operazione File System"
          [status]="!selectedAction.operation ? 'error' : null"
        ></sia-select-box>
        @if (selectedAction.operation == 'Move') {
          <sia-text-box
            label="Cartella di destinazione"
            [(value)]="selectedAction.destinationFolderPath"
            [disabled]="false"
          ></sia-text-box>
          <sia-select-box
            [selectBoxOptions]="{
              fixedDataSource: variables,
              value: selectedAction.propertyPathToMove,
            }"
            label="Variabile del path del file da muovere"
            [(value)]="selectedAction.propertyPathToMove"
            [disabled]="false"
          ></sia-select-box>
        }
        @if (selectedAction.operation == 'Rename') {
          <sia-text-box
            label="Percorso del file/cartella da rinominare"
            [(value)]="selectedAction.PropertyPathToRename"
            [disabled]="false"
          ></sia-text-box>
          <sia-text-box
            label="Nuovo nome del file"
            [(value)]="selectedAction.newFileName"
            [disabled]="false"
          ></sia-text-box>
        }

        @if (selectedAction.operation == 'Preview') {
          <sia-text-box
            label="Percorso del file da generare anteprima (immagini)"
            [(value)]="selectedAction.PropertyFilePath"
            [disabled]="false"
          ></sia-text-box>
          <sia-text-box
            label="FileSha256 del file da generare l'anteprima"
            [(value)]="selectedAction.PropertyFileSha256"
            [disabled]="false"
          ></sia-text-box>
        }
      }
      @case ('Extraction') {
        <sia-select-box
          [selectBoxOptions]="{
            fixedDataSource: variables,
            value: selectedAction.propertyTextToExtract,
          }"
          label="Variabile testo del file"
          [(value)]="selectedAction.propertyTextToExtract"
          [disabled]="false"
        ></sia-select-box>
        <sia-text-box
          label="Esempio"
          [(value)]="selectedAction.example"
          [disabled]="false"
        ></sia-text-box>
        <ng-container
          [ngTemplateOutlet]="accordionParameters"
          [ngTemplateOutletContext]="{ type: 'fieldToExtract' }"
        ></ng-container>
      }
      @case ('ChromaDB') {
        <sia-select-box
          [selectBoxOptions]="{
            fixedDataSource: chromaDBOperation,
            value: selectedAction.operation,
          }"
          [(value)]="selectedAction.operation"
          [disabled]="false"
          label="Operazione su ChromaDB"
        ></sia-select-box>
        <sia-text-box
          label="Collezione"
          [(value)]="selectedAction.collectionName"
          [disabled]="false"
          info="Nome della collezione nel database vettoriale"
        ></sia-text-box>
        <sia-text-box
          label="Propietà chunk"
          [(value)]="selectedAction.propertyChunks"
          [disabled]="false"
          info="Nome della collezione nel database vettoriale"
        ></sia-text-box>
        <sia-textarea-box
          label="Query SQL"
          [(value)]="selectedAction.query"
          [disabled]="false"
          [textAreaMinHeight]="200"
          [textAreaMaxHeightVh]="'200px'"
          [forceDisableAI]="true"
          info="Query SQL, ad esempio select, update o chiamata a stored procedure. Con @NomeVariabileInSQL è il placeholder tra query sql e variabile nel workflow. E' possibile settare il collegamento nella sezione Parametri."
        ></sia-textarea-box>
        <sia-number-box
          [(value)]="selectedAction.nResults"
          [numberBoxMax]="1.3"
          [numberBoxMin]="0"
          [decimals]="1"
          label="Max distance"
        ></sia-number-box>
        @if (
          selectedAction.operation == 'DELETE' ||
          selectedAction.operation == 'GET'
        ) {
          <ng-container
            [ngTemplateOutlet]="accordionParameters"
            [ngTemplateOutletContext]="{ type: 'parameters' }"
          ></ng-container>
        }
        @if (selectedAction.operation == 'GET') {
          <sia-number-box
            [(value)]="selectedAction.nResults"
            [numberBoxMax]="1"
            [numberBoxMin]="0"
            [decimals]="2"
            label="Threashold categoria"
            info="Viene assegnata una probabilità ad ogni categoria che deve essere classificata, da 0 a 1. Il valore deve essere superiore alla threshold in modo che venga selezionato"
          ></sia-number-box>
          <sia-select-box
            [selectBoxOptions]="{
              fixedDataSource: sqlResultTypes,
              value: selectedAction.queryType,
            }"
            label="Tipo di query"
            info="Se singola, ritorna un unico documento. Se multipla è necessario specificare il numero di documenti"
            [(value)]="selectedAction.queryType"
            [disabled]="false"
          ></sia-select-box>
          @if (selectedAction.queryType == 'multiple') {
            <sia-number-box
              [(value)]="selectedAction.nResults"
              [numberBoxMin]="1"
              label="Numero documenti ritornati"
              info="Numero di documenti che devono essere ritornati"
            ></sia-number-box>
          }
          <sia-select-box
            [selectBoxOptions]="{
              fixedDataSource: outputChromaDBTypes,
              value: selectedAction.outputType,
            }"
            label="Output della query"
            info="Output della query nel vector database"
            [(value)]="selectedAction.outputType"
            [disabled]="false"
          ></sia-select-box>
        }
      }
      @case ('OCR') {
        <sia-select-box
          [selectBoxOptions]="{
            fixedDataSource: variables,
            value: selectedAction.input,
          }"
          label="Variabile testo del file"
          [(value)]="selectedAction.input"
          [disabled]="false"
        ></sia-select-box>

        <sia-check-box
          [label]="'Estrazione semplice (senza layout)'"
          [(value)]="selectedAction.simpleTextExtraction"
        ></sia-check-box>
      }
      @case ('Classification') {
        <sia-select-box
          label="Group Key"
          [(value)]="selectedAction.groupKey"
          [selectBoxOptions]="{
            dbKey: 'fs.v_group_categories',
            foreignKey: 'id',
            value: selectedAction.groupKey,
            connectionStringName: 'ai',
          }"
          [foreignKey]="'Id'"
        ></sia-select-box>
        <sia-select-box
          [selectBoxOptions]="{
            fixedDataSource: classificationsTypes,
            value: selectedAction.classificationType,
          }"
          label="Classificazione"
          [(value)]="selectedAction.classificationType"
          [disabled]="false"
        ></sia-select-box>

        <!-- <sia-select-box
          [selectBoxOptions]="{
            fixedDataSource: variables,
            value: selectedAction.propertyTextToCategorize,
          }"
          label="Proprietà da categorizzare"
          [(value)]="selectedAction.propertyTextToCategorize"
          [disabled]="false"
          [status]="!selectedAction.propertyTextToCategorize ? 'error' : null"
        ></sia-select-box> -->

        <sia-number-box
          [(value)]="selectedAction.threashold"
          [numberBoxMax]="1"
          [numberBoxMin]="0"
          [decimals]="2"
          label="Threashold categoria"
          info="Viene assegnata una probabilità ad ogni categoria che deve essere classificata, da 0 a 1. Il valore deve essere superiore alla threshold in modo che venga selezionato"
        ></sia-number-box>
        <sia-check-box
          [label]="'Abilita LLM'"
          [(value)]="selectedAction.useLLM"
          (valueChange)="$event ? (selectedAction.useVisualLLM = false) : null"
        ></sia-check-box>
        <sia-check-box
          [label]="'Abilita LLM Visivo'"
          [(value)]="selectedAction.useVisualLLM"
          (valueChange)="$event ? (selectedAction.useLLM = false) : null"
        ></sia-check-box>
        @if (!selectedAction.useLLM && !selectedAction.useVisualLLM) {
          <sia-text-box
            label="Modello"
            [(value)]="selectedAction.model"
            [disabled]="false"
            info="Nome del modello per la classificazione"
          ></sia-text-box>

          <sia-text-box
            label="File da classificare"
            [(value)]="selectedAction.propertyFileToCategorize"
            [disabled]="false"
            info="Path del file da classificare con eventuale notazione filePath[0:4]"
          ></sia-text-box>
        }
      }
      @case ('Chunking') {
        <sia-select-box
          [selectBoxOptions]="{
            fixedDataSource: variables,
            value: selectedAction.propertyFilePath,
          }"
          label="Path del file"
          [(value)]="selectedAction.propertyFilePath"
          [disabled]="false"
          [status]="!selectedAction.propertyFilePath ? 'error' : null"
        ></sia-select-box>
        <div class="flex flex-row">
          @if (selectedAction.staticValue) {
            <sia-text-box
              class="w-1/2"
              label="Strategia di chunking"
              [(value)]="selectedAction.chunkingStrategy"
              [disabled]="false"
            ></sia-text-box>
          } @else {
            <sia-select-box
              class="!w-1/2"
              [selectBoxOptions]="{
                fixedDataSource: variables,
                value: selectedAction.propertyChunkingStrategy,
              }"
              label="Propietà di chunking"
              [(value)]="selectedAction.propertyChunkingStrategy"
              [disabled]="false"
            ></sia-select-box>
          }
          <sia-check-box
            class="w-1/2"
            [label]="'Valore fisso'"
            [(value)]="selectedAction.staticValue"
            (click)="clearChunkProperty(selectedAction)"
          ></sia-check-box>
        </div>
        <sia-select-box
          [selectBoxOptions]="{
            fixedDataSource: variables,
            value: selectedAction.propertyFileContent,
          }"
          label="Propietà contenuto file"
          [(value)]="selectedAction.propertyFileContent"
          [disabled]="false"
          [status]="!selectedAction.propertyFileContent ? 'error' : null"
        ></sia-select-box>
        <ng-container
          [ngTemplateOutlet]="accordionParameters"
          [ngTemplateOutletContext]="{ type: 'additionalMetadatas' }"
        ></ng-container>
      }
      @case ('Chat') {
        <sia-text-box
          label="Modello"
          [(value)]="selectedAction.model"
          [disabled]="false"
          info="Nome del modello allenato per la chat"
          [status]="!selectedAction.model ? 'error' : null"
        ></sia-text-box>
        <ng-container
          [ngTemplateOutlet]="accordionParameters"
          [ngTemplateOutletContext]="{ type: 'prompt' }"
        ></ng-container>
      }
      @case ('Trigger') {
        <sia-text-box
          label="Id workflow"
          [(value)]="selectedAction.workflowId"
          [disabled]="false"
          info="Id workflow da eseguire"
          [status]="!selectedAction.workflowId ? 'error' : null"
        ></sia-text-box>
      }
    }
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="save()">
    <mat-icon>save</mat-icon>
    {{ 'Salva e Chiudi' | siaTranslate }}
  </button>
</div>

<ng-template #accordionParameters let-type="type">
  @switch (type) {
    @case ('parameters') {
      <sia-accordion title="Parametri" class="mb-2">
        <div class="flex flex-col gap-2">
          <button mat-button (click)="addParameters()">
            <mat-icon>add</mat-icon>{{ 'Aggiungi' | siaTranslate }}
          </button>
          <div class="flex flex-col gap-2">
            @for (
              parameter of selectedAction.parameters;
              track selectedAction.parameters
            ) {
              <div
                class="surface flex w-full flex-row items-center gap-2 rounded-lg p-2"
              >
                <sia-text-box
                  class="w-1/3"
                  label="Nome"
                  [(value)]="parameter.name"
                  [disabled]="false"
                ></sia-text-box>
                @if (parameter.staticValue) {
                  <sia-text-box
                    class="w-1/3"
                    label="Valore"
                    [(value)]="parameter.value"
                    [disabled]="false"
                  ></sia-text-box>
                } @else {
                  <sia-select-box
                    class="!w-1/3"
                    [selectBoxOptions]="{
                      fixedDataSource: variables,
                      value: parameter.value,
                    }"
                    [(value)]="parameter.value"
                    [disabled]="false"
                    label="Parametri disponibili"
                  ></sia-select-box>
                }

                <sia-check-box
                  class="w-1/3"
                  [label]="'Valore fisso'"
                  [(value)]="parameter.staticValue"
                ></sia-check-box>
                <button
                  mat-icon-button
                  (click)="removeParameters(parameter)"
                  class="error"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </div>
      </sia-accordion>
    }
    @case ('additionalMetadatas') {
      <sia-accordion title="Metadati" class="mb-2">
        <div class="flex flex-col gap-2">
          <button mat-button (click)="addMetadata()">
            <mat-icon>add</mat-icon>{{ 'Aggiungi' | siaTranslate }}
          </button>
          <div class="flex flex-col gap-2">
            @for (
              additionalMetadata of selectedAction.additionalMetadatas;
              track selectedAction.additionalMetadatas
            ) {
              <div
                class="surface flex w-full flex-row items-center gap-2 rounded-lg p-2"
              >
                <sia-text-box
                  class="w-1/3"
                  label="Nome"
                  [(value)]="additionalMetadata.name"
                  [disabled]="false"
                ></sia-text-box>
                @if (additionalMetadata.staticValue) {
                  <sia-text-box
                    class="w-1/3"
                    label="Valore"
                    [(value)]="additionalMetadata.value"
                    [disabled]="false"
                  ></sia-text-box>
                } @else {
                  <sia-select-box
                    class="!w-1/3"
                    [selectBoxOptions]="{
                      fixedDataSource: variables,
                      value: additionalMetadata.value,
                    }"
                    [(value)]="additionalMetadata.value"
                    [disabled]="false"
                    label="Parametri disponibili"
                  ></sia-select-box>
                }
                <sia-check-box
                  class="w-1/3"
                  [label]="'Valore fisso'"
                  [(value)]="additionalMetadata.staticValue"
                ></sia-check-box>
                <button
                  mat-icon-button
                  (click)="removeMetadata(additionalMetadata)"
                  class="error"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </div>
      </sia-accordion>
    }
    @case ('fieldToExtract') {
      <sia-accordion title="Parametri da estrarre" class="mb-2">
        <div class="flex flex-col gap-2">
          <button mat-button (click)="addFiledToExtract()">
            <mat-icon>add</mat-icon>{{ 'Aggiungi' | siaTranslate }}
          </button>
          <div class="flex flex-col gap-2">
            @for (
              fieldToExtract of selectedAction.fieldsToExtract;
              track selectedAction.fieldsToExtract
            ) {
              <div
                class="surface flex w-full flex-row items-center gap-2 rounded-lg p-2"
              >
                <sia-text-box
                  class="w-1/3"
                  label="Id"
                  [(value)]="fieldToExtract.id"
                  [disabled]="false"
                ></sia-text-box>
                <sia-text-box
                  class="w-1/3"
                  label="Cosa estrarre"
                  [(value)]="fieldToExtract.whatToExtract"
                  [disabled]="false"
                ></sia-text-box>
                <sia-text-box
                  class="w-1/3"
                  label="Tipo di estrazione"
                  [(value)]="fieldToExtract.extractionType"
                  [disabled]="false"
                ></sia-text-box>

                <button
                  mat-icon-button
                  (click)="removeFiledToExtract(fieldToExtract)"
                  class="error"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </div>
      </sia-accordion>
    }
    @case ('prompt') {
      <sia-accordion
        title="Prompts"
        class="mb-2"
        [status]="
          !selectedAction.prompts || selectedAction.prompts == 0
            ? 'error'
            : null
        "
      >
        <div class="flex flex-col gap-2">
          <button mat-button (click)="addPrompt()">
            <mat-icon>add</mat-icon>{{ 'Aggiungi' | siaTranslate }}
          </button>
          <div class="flex flex-col gap-2">
            @for (
              prompt of selectedAction.prompts;
              track selectedAction.prompts
            ) {
              <div
                class="surface flex w-full flex-row items-center gap-2 rounded-lg p-2"
              >
                <sia-text-box
                  class="w-1/2"
                  label=" "
                  [(value)]="prompt.content"
                  [disabled]="false"
                ></sia-text-box>
                <sia-select-box
                  class="!w-1/2"
                  [selectBoxOptions]="{
                    fixedDataSource: roles,
                    value: prompt.role,
                  }"
                  [(value)]="prompt.role"
                  [disabled]="false"
                  label="Ruoli disponibili"
                ></sia-select-box>
                <button
                  mat-icon-button
                  (click)="removePrompt(prompt)"
                  class="error"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </div>
      </sia-accordion>
    }
  }
</ng-template>
